<div class="huddle-creation-panel-container">
  <div class="blank-space" (click)="onClose()"></div>
  <div class="huddle-creation-modal">
    <div class="huddle-creation-modal-header">
      <div class="header-label">{{huddleMeetingName}}</div>
      <button class="close-button" (click)="onClose()">
        <img src="assets/images/close.svg">
      </button>
    </div>
    <div class="huddle-creation-modal-body">
      <div class="huddle-creation-tabs">
        <div class="huddle-creation-tab" [class.active]="activeTab == 'spotlights'"
          (click)="changeCreationTab('spotlights')">Spotlight</div>
        <div class="huddle-creation-tab" [class.active]="activeTab == 'actions'" (click)="changeCreationTab('actions')">
          Action Plan</div>
        <div class="huddle-creation-tab" [class.active]="activeTab == 'escalations'"
          (click)="changeCreationTab('escalations')">Suggestion</div>
      </div>
      <div class="huddle-creation-tab-contents">
        <div class="huddle-creation-tab-content" *ngIf="activeTab == 'spotlights'">
          <div class="huddle-creation-top-panel">
            <button (click)="initFieldForDataCreation()" [disabled]="!isAddButtonEnabled">Add new Spotlight</button>
          </div>
          <div class="huddle-creation-field-container"
            *ngIf="modulesConfigs && modulesConfigs.spotlights && modulesConfigs.spotlights.brandId">
            <div class="huddle-spotlight-custom-field-container"
              id="huddle_new_accordion_{{modulesConfigs.spotlights.brandId}}" [class.show]="isFieldRendered"></div>
            <div class="huddle-creation-action-btn-container" *ngIf="isActionButtonVisible">
              <button class="cancel-button" (click)="cancelDataCreation()">Cancel</button>
              <button class="apply-button" (click)="updateFieldValues()">Submit</button>
            </div>
          </div>
          <div class="huddle-creation-table-container">
            <div class="table-holder"
              *ngIf="modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length">
              <app-overview-table [config]="tableConfigs[activeTab].config"
                (delete)="removeDataFromList($event,modulesConfigs[activeTab].brandId)"
                [columns]="tableConfigs[activeTab].header"
                [rows]="brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows"></app-overview-table>
            </div>
            <div
              *ngIf="!isActionButtonVisible && !(modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length)"
              class="no-data-found">
              Please click on ‘Add New Spotlight’ to add data.
            </div>
          </div>
        </div>
        <div class="huddle-creation-tab-content" *ngIf="activeTab == 'actions'">
          <div class="huddle-creation-top-panel">
            <button (click)="initFieldForDataCreation()" [disabled]="!isAddButtonEnabled">Add New Action Plan</button>
          </div>
          <div class="huddle-creation-field-container"
            *ngIf="modulesConfigs && modulesConfigs.actions && modulesConfigs.actions.brandId">
            <div class="huddle-action-custom-field-container"
              id="huddle_new_accordion_{{modulesConfigs.actions.brandId}}" [class.show]="isFieldRendered"></div>
            <div class="huddle-creation-action-btn-container" *ngIf="isActionButtonVisible">
              <button class="cancel-button" (click)="cancelDataCreation()">Cancel</button>
              <button class="apply-button" (click)="updateFieldValues()">Submit</button>
            </div>
          </div>
          <div class="huddle-creation-table-container">
            <div class="table-holder"
              *ngIf="modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length">
              <app-overview-table [config]="tableConfigs[activeTab].config"
                (delete)="removeDataFromList($event,modulesConfigs[activeTab].brandId)"
                [columns]="tableConfigs[activeTab].header"
                [rows]="brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows"></app-overview-table>
            </div>
            <div
              *ngIf="!isActionButtonVisible && !(modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length)"
              class="no-data-found">
               Please click on ‘Add New Action Plan’ to add data.
            </div>
          </div>
        </div>
        <div class="huddle-creation-tab-content" *ngIf="activeTab == 'escalations'">
          <div class="huddle-creation-top-panel">
            <button (click)="initFieldForDataCreation()" [disabled]="!isAddButtonEnabled">Add new Suggestion</button>
          </div>
          <div class="huddle-creation-field-container"
            *ngIf="modulesConfigs && modulesConfigs.escalations && modulesConfigs.escalations.brandId">
            <div class="huddle-escalations-custom-field-container"
              id="huddle_new_accordion_{{modulesConfigs.escalations.brandId}}" [class.show]="isFieldRendered"></div>
            <div class="huddle-creation-action-btn-container" *ngIf="isActionButtonVisible">
              <button class="cancel-button" (click)="cancelDataCreation()">Cancel</button>
              <button class="apply-button" (click)="updateFieldValues()">Submit</button>
            </div>
          </div>
          <div class="huddle-creation-table-container">
            <div class="table-holder"
              *ngIf="modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length">
              <app-overview-table [config]="tableConfigs[activeTab].config"
                (delete)="removeDataFromList($event,modulesConfigs[activeTab].brandId)"
                [columns]="tableConfigs[activeTab].header"
                [rows]="brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows"></app-overview-table>
            </div>
            <div
              *ngIf="!isActionButtonVisible && !(modulesConfigs && modulesConfigs[activeTab] && modulesConfigs[activeTab].brandId && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows && brandWiseModuleConfigs[modulesConfigs[activeTab].brandId].rows.length)"
              class="no-data-found">
              Please click on ‘Add New Suggestion’ to add data.
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="huddle-creation-modal-footer">
      <div class="huddle-creation-modal-footer-left"></div>
      <div class="huddle-creation-modal-footer-right">
        <button class="clear-button" [disabled]="!isUpdateButtonEnabled" (click)="clearAllFields()">
          Clear all
        </button>
        <button class="apply-button" [disabled]="!isUpdateButtonEnabled" (click)="saveHuddleDetails()">
          Update
        </button>
      </div>
    </div>
  </div>
</div>